import en from "@/assets/locales/en.json";
import minion from "@/assets/locales/minion.json";
import pirate from "@/assets/locales/pirate.json";

export const locales = {
  en,
  pirate,
  minion,
};

export type Locales = keyof typeof locales;
